import React from 'react'
import styled from 'styled-components'

const StyledLoader = styled.div`
  display: inline-block;
  width: 30px;
  height: 30px;
  position: relative;
  border: 4px solid #555555;
  top: 50%;
  animation: loader 4s infinite ease;

  .loader-inner {
    vertical-align: top;
    display: inline-block;
    width: 100%;
    background-color: #555555;
    animation: loader-inner 4s infinite ease-in;
  }
  @keyframes loader {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(180deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(360deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes loader-inner {
    0% {
      height: 0%;
    }
    25% {
      height: 0%;
    }
    50% {
      height: 100%;
    }
    75% {
      height: 100%;
    }
    100% {
      height: 0%;
    }
  }
`

const Loader = () => (
  <StyledLoader>
    <div className="loader-inner"></div>
  </StyledLoader>
)

export default Loader
